import type { FunctionComponent } from 'react'
import React, { useContext, useState } from 'react'

import classnames from 'classnames'

import type { ReviewsProduct } from '../../../../../generated/frontend'
import { usePageProps } from '../../../../../shared/usePageProps'
import styles from '../../ProductListingPage.module.scss'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import { AppliedFilters, ProductCount, Products, ReviewsPagination, SeoContentBlock } from '..'

export const ReviewsProducts: FunctionComponent = () => {
  const { state } = useContext(ReviewsTemplateContext)

  const {
    scoreStatement,
    productsWithPagination,
    articleListingWithImage,
    needsBasedFilters,
    filters: basicFilters,
    seoContentBlock,
    meta,
  } = state.productListingPageData

  const { taxonomySlug } = productsWithPagination

  const { userAccessState, savedItems } = usePageProps()
  const savedProducts = savedItems?.find((i) => i.categorySlug === taxonomySlug)?.products ?? []

  const productsRef = React.useRef(null)
  const isBrandCanonical = meta.canonical.endsWith('brand')
  const [removeFilterMessage, setRemoveFilterMessage] = useState<string>('')

  return (
    <>
      <AppliedFilters
        basicFilters={basicFilters}
        needsBasedFilters={needsBasedFilters}
        data-testid="reviews-applied-filters"
        removeFilterMessage={removeFilterMessage}
        handleRemoveFilterMessage={setRemoveFilterMessage}
      />
      <ProductCount
        {...productsWithPagination.productCount}
        className={classnames(styles.productCountInProducts)}
        data-testid="products-product-count"
      />
      <Products
        products={productsWithPagination.products as ReviewsProduct[]}
        taxonomySlug={taxonomySlug}
        scoreStatement={scoreStatement}
        data-testid="reviews-products"
        articleListingWithImage={articleListingWithImage}
        ref={productsRef}
        loginStatus={userAccessState?.transformTypeDecision || ''}
        savedProducts={savedProducts}
      />
      <ReviewsPagination
        numberOfPages={productsWithPagination?.numberOfPages}
        data-testid="pagination"
        ref={productsRef}
      />
      {typeof seoContentBlock === 'string' && seoContentBlock.length > 0 && !isBrandCanonical && (
        <SeoContentBlock contentString={seoContentBlock} />
      )}
    </>
  )
}
